export default "__VITE_PUBLIC_ASSET__fbf32536__"